import '@fontsource/raleway';
import './src/styles/theme.css';
import rootWrapper from './root-wrapper';

export const wrapRootElement = rootWrapper;
